import React from 'react';
import PropTypes from 'prop-types';
import UploadImage from '../../assets/images/notificationicon.jpg';
import { useLocaleContext } from '../context/LocaleContext';
import { Tr, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { getFormattedDate } from '../utils/utils';
import { Typography } from '@telus-uds/components-web';
import { LinkButton } from "../design/css";
import { GET_RESOLVED_DAYS, GET_WORKING_DAYS, GET_DEFECT_LOCALE } from './constants';
import EN from '../../EN.json';
import FR from '../../FR.json';

const Row = ({ defect, index, selectedDefect, openModal, userProfile }) => {
    const locale = useLocaleContext();
    const { DEFECT_MANAGEMENT: { VIEW } = {} } = locale === 'en-US' ? EN : FR;
    const {
        defectWebform = '',
        defectCategory = '',
        createdAt = '',
        name = '',
        priority = '',
        status = '',
        moved_to_in_progress_at = '',
        resolved_at = '',
        defectAssignedTo = {}
    } = defect || {};

    let count = 0
    const getOpenDays = () => {
        const inProgress = "In Progress" || "En cours"
        const resolved = "Resolved" || "Résolu"
        const closed = "Closed - No response received" || "Fermé - aucune réponse reçue"
        if (status === inProgress && moved_to_in_progress_at) { // In Progress
            count = GET_WORKING_DAYS(moved_to_in_progress_at);
        }
        if (status === resolved || status === closed) { // Resolved Or Closed
            if (moved_to_in_progress_at && resolved_at)
                count = GET_RESOLVED_DAYS(moved_to_in_progress_at, resolved_at);
        }
        return count
    }
    return (
        <Tr style={{ background: index % 2 === 0 ? '#f9f1ff' : '#ffffff' }}>
            {userProfile.role.name === 'ADMIN' ?
                <Td style={{ borderRight: '1px solid #e7e7e7' }}>
                    {defect.id}{defect.new_update_for_admin === true ? <img
                        src={UploadImage}
                        style={{ marginBottom: "12px" }}
                        width={12}
                        height={12}
                        alt="upload-file"
                    /> : ''}
                </Td>
                :
                <Td style={{ borderRight: '1px solid #e7e7e7' }}>
                    {defect.id}{defect.new_update_for_reporter === true ? <img
                        src={UploadImage}
                        style={{ marginBottom: "12px" }}
                        width={12}
                        height={12}
                        alt="upload-file"
                    /> : ''}
                </Td>
            }
            <Td style={{ borderRight: '1px solid #e7e7e7' }}>
                <Typography>{getFormattedDate(createdAt, 'YYYY-MM-DD') || '-'}</Typography>
            </Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{getOpenDays()}</Typography></Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{GET_DEFECT_LOCALE(defectWebform)}</Typography></Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{name}</Typography></Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{GET_DEFECT_LOCALE(defectCategory)}</Typography></Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{GET_DEFECT_LOCALE(priority)}</Typography></Td>
            <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{GET_DEFECT_LOCALE(status)}</Typography></Td>
            {userProfile.role.name === 'ADMIN' ?
                <Td style={{ borderRight: '1px solid #e7e7e7' }}><Typography>{defectAssignedTo ? `${defectAssignedTo.firstName} ${defectAssignedTo.lastName}` : ''}</Typography></Td> : ''}
            <Td style={{ borderRight: '1px solid #e7e7e7' }}>
                <LinkButton onClick={() => {
                    selectedDefect(defect);
                    openModal(true);
                }}><Typography>{VIEW}</Typography></LinkButton>
            </Td>
        </Tr>
    );
};

Row.propTypes = {
    defect: PropTypes.objectOf(PropTypes.object).isRequired,
    index: PropTypes.number.isRequired,
    selectedDefect: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired
};

export default Row;
